<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-layer-group"></i>
        에이전트 설치 이력
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">이력</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">설치</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col>
        <!-- detail search start -->
        <b-card v-show="so.adv">
        <b-row>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="opt_date">설치 날짜</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <b-form-group>
              <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1일</b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1주</b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1달</b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1주</b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1달</b-button>
              <b-form inline class="mt-2">
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
            <label class="col-form-label" for="opt_date">삭제 날짜</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
            <b-form-group>
              <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('', 'deleted_at')"><i class="fa fa-remove"></i></b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d', 'deleted_at')">-1일</b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w', 'deleted_at')">-1주</b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m', 'deleted_at')">-1달</b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w', 'deleted_at')">1주</b-button>
              <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m', 'deleted_at')">1달</b-button>
              <b-form inline class="mt-2">
                <date-picker @change="refresh" v-model="so.opt.deleted_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.deleted_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
            <label class="col-form-label" for="opt_user_reason">이유</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 align-self-center">
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_user_reason" v-model="so.opt['reason']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
            <label class="col-form-label" for="ph_search_opt_type">일치 유형</label>
          </b-col>
          <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-2">
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">모두 일치</b-form-radio>
                <b-form-radio value="or">최소 한개 이상 일치</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3 float-right">
          <b-form-group>
            <b-button size="sm" variant="add" @click="refresh"> 찾기 </b-button>
            <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
            <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
          </b-form-group>
        </b-row>
      </b-card>
      <!-- detail search end -->
      <div class="d-flex flex-wrap align-items-center">
          <b-col sm="2">
          </b-col>
          <b-col class="md-10 d-flex flex-wrap align-items-center">
            <b-input-group size="sm">
              <div class="mr-auto mb7"></div>
              <div class="mr-2 mb7 mt-2">
                <button class="btn btn-icon mr-1" style="border-color: #e4e7ea" @click="refresh()">
                  <i class="fas fa-sync-alt"></i>
                </button>
                <button class="btn btn-icon mr-1" style="border-color: #e4e7ea" @click="reset()">
                  <i class="fas fa-times"></i>
                </button>
              </div>
              <div class="mr-2 mb7">
                <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || '찾기'" v-model="so.sk" @change="sv_reset">
                  <option disabled value="">검색</option>
                  <option v-if="!user" value="reason">이유</option>
                  <option value="type">보안 설정</option>
                  <option value="is_del">상태</option>
                </select>
              </div>
              <div class="mr-2 mb7">
                <select class="form-control" :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'type'" @change="$refs._list.refresh()">
                  <option disabled value="">보안 설정을 선택하세요</option>
                  <option value="WAF">WAF</option>
                  <option value="WSFinder">WSFinder</option>
                  <option value="WMDS">WMDS</option>
                </select>
              </div>
              <div class="mr-2 mb7">
                <select class="form-control" :disabled="so.adv" v-model="so.sv" v-if="so.sk == 'is_del'" @change="$refs._list.refresh()">
                  <option disabled value="">활성화 유무를 선택하세요</option>
                  <option value="true">삭제</option>
                  <option value="false">활성화</option>
                </select>
              </div>
              <div class="mr-2 mb7">
                <b-form-input class="form-control col-xl-12" :disabled="so.adv" v-if="so.sk != 'is_del' && so.sk != 'type'" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
              </div>
              <div class="mb7">
                <button class="btn btn-icon1 mr-1" @click="refresh">
                  <i class="fas fa-search"></i>
                </button>
                <!-- <button class="btn btn-icon2" @click="search_opt">
                  <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
                </button> -->
              </div>
            </b-input-group>
            <br>
            <b-input-group size="sm">
              <div class="mr-auto mb7">
              </div>
              <div class="mb7 mr-2 mt-2">
                <div class="custom-control custom-checkbox">
                  <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">삭제된 항목 숨기기</b-checkbox>
                </div>
              </div>
              <div class="mb7 mr-2">
                <select class="form-control" v-model="so.perPage" @change="refresh" style="margin-right:15px">
                    <option disabled value="15">표시되는 개수 : 기본 15개</option>
                    <option value=10>10</option>
                    <option value=50>50</option>
                    <option value=100>100</option>
                  </select>

                  <select class="form-control" v-if="sync.enable" v-model="sync.interval" @change="refresh" style="margin-right:15px">
                    <option disabled value="15">Please select interval : Default 15</option>
                    <option value=10>10</option>
                    <option value=30>30</option>
                    <option value=60>60</option>
                    <option value=300>300(5 min)</option>
                  </select>
                  <span v-if="sync.enable" class="float-right" style="margin-right:15px">
                    <i :class="`fa fa-refresh ${sync.th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
                    <b-btn @click="pause" size="sm" variant="warning">
                      {{!sync.stop ? "Auto refresh"  : "Pause"}}
                    </b-btn>
                  </span>
              </div>
            </b-input-group>
          </b-col>
        </div>
        <div class="reg_card">
          <div class="reg_card_body">
            <div class="table-responsive">
              <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요." :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
                <template slot="created_at" slot-scope="row">{{ row.item.created_at | datetime }}</template>
                <template slot="deleted_at" slot-scope="row">
                  <b-badge v-if="row.item.deleted_at == null || row.item.deleted_at == ''">-</b-badge>
                  <b-badge v-else variant="secondary">{{row.item.deleted_at | datetime}}</b-badge>
                </template>
                <template slot="type" slot-scope="row">
                  <b-badge v-if="!row.item.is_del" variant="success">
                    {{row.item.type}}
                  </b-badge>
                  <span v-else>
                    <del>{{row.item.type}}</del>
                  </span>
                </template>
                <template slot="reason" slot-scope="row">
                  {{row.item.reason}}
                </template>
                <template slot="agent" slot-scope="row">
                  <b-btn @click="detail_agent(row.item)" size="sm" class="btn btn-sm btn-insert">더보기</b-btn>
                </template>
                <template slot="service" slot-scope="row">
                  <b-btn @click="detail_service(row.item)" size="sm" class="btn btn-sm btn-insert">더보기</b-btn>
                </template>
                <template slot="group" slot-scope="row">
                  <b-btn @click="detail_group(row.item)" size="sm" class="btn btn-sm btn-insert">더보기</b-btn>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <b-row class="mt30">
          <b-col class="pagination justify-content-center">
            <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-modal title="그룹 안내" v-model="modal_group" hide-footer>
      <table class="table table_add table-striped">
        <thead>
          <tr>
            <th>제목</th>
            <th>설명</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>회사명</td>
            <td>{{modal_group_info.groupname}}</td>
          </tr>
          <tr>
            <td>가입일</td>
            <td>{{modal_group_info.created_at | sdate}}</td>
          </tr>
          <tr>
            <td>서비스</td>
            <td>{{modal_group_info.service}}</td>
          </tr>
          <tr>
            <td>사용자 수</td>
            <td>{{modal_group_info.count}} 명</td>
          </tr>
        </tbody>
      </table>
      <!-- {{modal_group_info}} -->
      <b-button class="mt-3 float-right" @click="modal_group = false" variant="info">확인</b-button>
    </b-modal>
    <b-modal title="에이전트 안내"  class="modal-dark" v-model="modal_agent" hide-footer>
      <table class="table table_add table-striped">
        <thead>
          <tr>
            <th>제목</th>
            <th>설명</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>에이전트 이름</td>
            <td>{{modal_agent_info.name ? modal_agent_info.name : modal_agent_info.nickname}}</td>
          </tr>
          <tr>
            <td>{{modal_agent_info.fqdn ? 'FQDN' : '버전'}}</td>
            <td>{{modal_agent_info.fqdn ? modal_agent_info.fqdn : modal_agent_info.version}}</td>
          </tr>
          <tr>
            <td>OS</td>
            <td>{{modal_agent_info.os_type ? modal_agent_info.os_type : (modal_agent_info.os ? modal_agent_info.os : '-')}}</td>
          </tr>
        </tbody>
      </table>
      <b-button class="mt-3 float-right" @click="modal_agent = false" variant="info">확인</b-button>
    </b-modal>
    <b-modal title="서비스 안내" v-model="modal_service" hide-footer>
      <table class="table table_add table-striped">
        <thead>
          <tr>
            <th>제목</th>
            <th>설명</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>서비스명</td>
            <td>{{modal_service_info.service_name}}</td>
          </tr>
          <tr>
            <td>가입일</td>
            <td>{{modal_service_info.created_at | sdate}}</td>
          </tr>
        </tbody>
      </table>
      <b-button class="mt-3 float-right" @click="modal_service = false" variant="info">확인</b-button>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>